// Angular
import { NgModule } from '@angular/core';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

// Dates
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MY_FORMATS } from './validators/date.validator';

// Modules
import { AppRoutingModule } from './app-routing.module';
import { MaterialModule } from './material/material.module';
// import { GooglePlaceModule } from 'ngx-google-places-autocomplete';

// Services
import { WindowService } from './services/window.service';

// Directives
import { ScrollSpyDirective } from './scroll-spy.directive';

// Google Maps
import { NgxGpAutocompleteModule } from '@angular-magic/ngx-gp-autocomplete';
import { Loader } from '@googlemaps/js-api-loader';

// Interceptors
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorInterceptor } from './app-error.interceptor';

// Components
import { AppComponent } from './app.component';
import { ShellComponent } from './shell/shell.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { HomePageComponent } from './home-page/home-page.component';
import { ContactPageComponent } from './contact-page/contact-page.component';
import { AboutPageComponent } from './about-page/about-page.component';
import { PlanManagementPageComponent } from './plan-management-page/plan-management-page.component';
import { ServiceAgreementPageComponent } from './service-agreement-page/service-agreement-page.component';
import { ServiceAgreementSentPageComponent } from './service-agreement-sent-page/service-agreement-sent-page.component';
import { PrivacyPageComponent } from './privacy-page/privacy-page.component';
import { ComplaintsPageComponent } from './complaints-page/complaints-page.component';
import { TestimonialsComponent } from './testimonials/testimonials.component';
import { ServerErrorPageComponent } from './server-error-page/server-error-page.component';
import { ComplaintSentPageComponent } from './complaint-sent-page/complaint-sent-page.component';
import { FooterComponent } from './footer/footer.component';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { SeoService } from './services/seo.service';
import { NdisNumberValidator } from './validators/ndis-number.validator';
import { EnquirySentComponent } from './enquiry-sent/enquiry-sent.component';
import { CalendarHeaderComponent } from './calendar-header/calendar-header.component';
import { ErrorComponent } from './error/error.component';
import { TestimonialFaderComponent } from './testimonial-fader/testimonial-fader.component';
import { AppHttpInterceptor } from './app-http.interceptor';

@NgModule({
  declarations: [
    AppComponent,
    ShellComponent,
    TermsAndConditionsComponent,
    NotFoundComponent,
    HomePageComponent,
    ContactPageComponent,
    AboutPageComponent,
    PlanManagementPageComponent,
    ServiceAgreementPageComponent,
    ServiceAgreementSentPageComponent,
    PrivacyPageComponent,
    ComplaintsPageComponent,
    TestimonialsComponent,
    ServerErrorPageComponent,
    ComplaintSentPageComponent,
    FooterComponent,
    EnquirySentComponent,
    CalendarHeaderComponent,
    ErrorComponent,
    TestimonialFaderComponent,
    ScrollSpyDirective
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    BrowserAnimationsModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    FormsModule,
    MaterialModule,
    NgxGpAutocompleteModule,
    // GooglePlaceModule
  ],
  providers: [
    WindowService,
    CurrencyPipe,
    SeoService,
    DatePipe,
    NdisNumberValidator,
    { provide: MAT_DATE_LOCALE, useValue: 'en-AU' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true },
    {
      provide: Loader,
      useValue: new Loader({
        apiKey: 'AIzaSyAMQ8zSynGXPYXZje6Y8VAhkO4h1BxNGJw',
        libraries: ['places']
      })
    },
    provideClientHydration()
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
